import UnitTestView   from 'scripts/defa/unit-tests/view-unit-test-view';

/**
 * defa.views.UnitTestCollectionView
 * A view for viewing a collection of tests.
 * @version 1.2.0
 */
import CollectionView from 'scripts/poppet/collection-view';

const UnitTestCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: UnitTestView,
	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	/**
	 * Show one new test for each 400 ms. Trigger feedback:ready
	 * when the collection is out of tests.
	 * @void
	 */
	onAttach: function () {
		
		let i      = 0,
			self   = this,
			$tests = self.$el.children();
		
		
		let intv = setInterval( function () {
			
			if ( i === $tests.length ) {
				clearInterval( intv );
				self.trigger( 'feedback:ready' );
				
			} else {
				$tests.eq( i ).removeClass( 'hidden' ).addClass( 'fade-in' );
				// OBS: Not connected to the poppet, this one
				// runs by itself. ( place duration and easing and offset in one location? )
				$( window ).scrollTo(
					$tests.eq( i ),
					{
						duration: 460,
						easing  : 'easeOutExpo',
						offset  : -60
					}
				);
			}
			
			i++;
			
		}, 500 );
	}
	
} );

export default UnitTestCollectionView;